module.exports = __webpack_public_path__ + "img/nature-13.34ebba9e.jpg";